import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={9.381}
    height={25.989}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 4480 12411"
    {...props}
  >
    <path
      d="M1476 9849v-290h1527v290H1476zm1527 561H1476v-294h1527v294zm0 562H1476v-295h1527v295zm-283 553h-960c-156 0-284-127-284-284 0-2 1527-2 1527-2 0 164-131 286-283 286zm-268 551h-424l-43-284h510l-43 284zm-434-3852h444v1069h-444V8224zm89-267h-542l303-3602h239v3602zm266 0V4355h238l303 3602h-541zM336 7058c-10-2106 665-3138 1323-4294 364-638 711-1424 540-2428 0-1 0 0 2 2 705 1015 189 1562 840 3007 512 1136 1109 2450 1103 3713-5 1333-514 1769-963 2153-32 27-63 55-94 82h-358V8224h208l8 100c6 72 69 128 144 122 74-7 128-71 122-144l-6-78h224c74 0 134-60 134-134 0-73-60-133-134-133h-247l-303-3602h189c74 0 134-60 134-133 0-74-60-134-134-134h-211l-9-100c-6-73-72-128-144-121-73 6-128 70-122 144l7 77h-216v-89c0-73-59-133-133-133s-133 60-133 133v89h-216l7-77c6-74-49-138-122-144s-138 48-144 121l-9 100h-211c-74 0-134 60-134 134 0 73 60 133 134 133h189l-303 3602h-248c-73 0-133 60-133 133 0 74 60 134 133 134h225l-6 78c-6 73 48 137 122 144 75 6 138-50 144-122l8-100h208v1069h-358C869 8835 342 8443 336 7058zm3019 2356c468-401 1050-900 1056-2355 6-1313-641-2745-1068-3692-288-638-369-956-432-1667-43-477-83-927-491-1514-165-237-536-86-487 199 160 917-166 1650-505 2247C748 3825 59 4877 69 7059c6 1455 588 1954 1056 2355 29 24 57 49 85 73v362h-75c-74 0-134 59-134 133s60 134 134 134h75v294h-75c-74 0-134 60-134 134 0 73 60 133 134 133h75v295h-75c-74 0-134 60-134 133 0 74 60 134 134 134h75c0 290 222 527 505 550l67 440c10 65 66 113 131 113h653c66 0 122-48 132-113l67-440c283-23 505-260 505-548 0-2 75-2 75-2 74 0 134-60 134-134 0-73-60-133-134-133h-75v-295h75c74 0 134-60 134-133 0-74-60-134-134-134h-75v-294h75c74 0 134-60 134-134s-60-133-134-133h-75v-362c28-24 56-49 85-73z"
      style={{
        fill: "#2b2a29",
        // stroke: "#000",
        strokeWidth: 137.535,
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
